/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/comps/SideBar.tsx
 * @Description: 侧边导航
 */
import { apiGetOrderStatusCount } from 'api/mall';
import { useContext, useEffect, useState, useCallback } from 'react';
import { CartContext, SiteContext, UserContext } from 'libs/contexts';
import { throttle } from 'rambdax';
import { getScroll } from 'libs/utils';
import { cls } from 'reactutils';

const ShopingCart = {
  title: '购物车',
  href: '/shopping_cart',
  icon: 'icon-shoppingCart',
  badge: 0,
  show: true,
};
const WaitReceive = {
  title: '待收货',
  href: '/purchaser/trade/list?status=60&commonStatus=1',
  icon: 'icon-daishouhuo',
  badge: 0,
  show: true,
};
const SalesReturning = {
  title: '退货中',
  href: '/purchaser/trade_return/list?or=1',
  icon: 'icon-tuihuozhong',
  badge: 0,
  show: true,
};
const WaitSettlement = {
  title: '待结算',
  href: '/purchaser/settle_income/list?status=10',
  icon: 'icon-shijian',
  badge: 0,
  show: false,
};
const WaitPayment = {
  title: '待付款',
  href: '/purchaser/settle_income/list?hasPaymentDue=true',
  icon: 'icon-daifukuan',
  badge: 0,
  show: false,
};
const BackToTop = {
  title: '回顶部',
  href: '#__next',
  icon: 'icon-backUp',
  badge: 0,
  show: false,
};
const SideBar = ({ fixedHeight = 242, backTopHeight = 500 }) => {
  const userInfo = useContext(UserContext);
  const site = useContext(SiteContext);
  const { quantity } = useContext(CartContext);
  const [positionType, setPositionType] = useState('absolute');
  const [list, setList] = useState([
    ShopingCart,
    WaitReceive,
    SalesReturning,
    WaitSettlement,
    WaitPayment,
    BackToTop,
  ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = useCallback(
    throttle((e: Event) => {
      const scrollTop = getScroll(e.target as HTMLElement, true);
      if (scrollTop >= backTopHeight) {
        const arr = [...list];
        BackToTop.show = true;
        setList(arr);
      } else if (scrollTop < backTopHeight) {
        const arr = [...list];
        BackToTop.show = false;
        setList(arr);
      }
      if (scrollTop >= fixedHeight) {
        setPositionType('fixed');
      } else if (scrollTop < fixedHeight) {
        setPositionType('absolute');
      }
    }, 30),
    [fixedHeight, backTopHeight],
  );

  if (typeof window === 'object' && userInfo?.isPurchaser) {
    window.addEventListener('scroll', handleScroll);
  }
  useEffect(() => {
    apiGetOrderStatusCount().then((res) => {
      if (!res?.data) return;
      const arr = [...list];
      WaitReceive.badge = res.data.waitReceiveTotalCount;
      SalesReturning.badge = res.data.returningTotalCount;
      setList(arr);
    });
  }, []);
  useEffect(() => {
    ShopingCart.badge = quantity;
    setList([...list]);
  }, [quantity]);
  useEffect(() => {
    return () => {
      window?.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, userInfo]);
  return (
    <div className={cls('side-bar-box', positionType)}>
      {userInfo?.isPurchaser && (
        <div className="side-bar">
          {list
            .filter((v) => v.show)
            .map((v) => (
              <a key={v.href} className="side-bar-item" title={v.title} href={v.href}>
                <div className="side-bar-icon">
                  <i className={cls('iconfont', v.icon)} />
                </div>
                <div className="side-bar-text shopping-cart-text">{v.title}</div>
                {v.badge ? <div className="side-bar-badge J_SideBarCount">{v.badge}</div> : ''}
              </a>
            ))}
        </div>
      )}
      <style jsx>{`
        .side-bar-box {
            position: absolute;
            top: 100px;
            left: 50%;
            margin-left: 630px;
            z-index: 666;
            text-align: center;
            background: rgba(35,35,39,.9);
            box-shadow: 0 4px 10px 0 rgba(0,0,0,.1);
        }
        .fixed {
            position: fixed;
            top: 100px;
        }
        .side-bar-item {
            width: 50px;
            position: relative;
            display: block;
            padding: 6px 0;
            color: #fff;
            border-bottom: 1px solid #464648;
            transition: all .3s ease;
            cursor: pointer;
        }
        .side-bar-item:hover {
            background-color: ${site.global?.platformMainColor};
        }
        .side-bar-icon {
            color: #fff;
        }
        .shopping-cart-text {
            font-size: 12px;
        }
        .side-bar-badge {
            display: inline-block;
            position: absolute;
            top: 6px;
            right: 0;
            height: 14px;
            padding-top: 1px;
            padding-left: 2px;
            padding-right: 2px;
            font-size: 12px;
            line-height: 12px;
            min-width: 21px;
            width: auto;
            background-color: ${site.global?.platformMainColor};
            border-radius: 8px;
            color: #fff;
            transition: all .3s ease;
        }
        .side-bar .side-bar-item:hover .side-bar-badge {
            background-color: #fff;
            color: ${site.global?.platformMainColor};
        }
        .iconfont {
            font-size: 19px;
        }
        `}</style>
    </div>
  );
};
export default SideBar;
